const LOCAL_BACKEND_BASE_URL = 'http://localhost:5000';
const PRODUCTION_BACKEND_BASE_PATH = '/backend';

export function getBackendBaseUrl() {
  return process.env.NODE_ENV === 'development'
    ? LOCAL_BACKEND_BASE_URL
    : PRODUCTION_BACKEND_BASE_PATH;
}

export function buildBackendUrl(path = '') {
  const baseUrl = getBackendBaseUrl().replace(/\/$/, '');
  const normalizedPath = String(path || '').startsWith('/')
    ? String(path || '')
    : `/${path || ''}`;
  return `${baseUrl}${normalizedPath}`;
}
